/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Table, Form, Grid, Button, Pagination, Loader } from "semantic-ui-react";
import ReactDOM from "react-dom";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";

const addressRegex = new RegExp("^[0-9][0-9]*$");

const logListBeginMultiplier = 50;
const logListEndMultiplier = 49;

const UtilsInstance = new Utils();
var cameFromLiveListClick = false;

class EventLog extends Component {

  // Intialize this component state with an empty log list
  constructor(props) {
    super(props);
    this.state = {
      formInput: "",
      originalLogList: [],
      activeLogList: [],
      filteredLogList: [],
      currentPage: 1,
      isLoadingActive: false,
      // Controller para cancelar requests caso saia da tela
      controller: new AbortController()
    };
    cameFromLiveListClick = false;
  }

  showLoading = () => this.setState({ isLoadingActive: true })
  hideLoading = () => this.setState({ isLoadingActive: false })

  handleAddressSearch = () => {
    const len = this.state.originalLogList.length;
    const searchedLogEntries = [];

    for (let i = 0; i < len; i++) {
      if (this.state.originalLogList[i].address !== undefined && this.state.originalLogList[i].address !== null) {
        if (this.state.originalLogList[i].address.toString() === this.state.formInput.toString()) {
          searchedLogEntries.push(this.state.originalLogList[i]);
        }
      }
    }
    // Show all entries that matched the event number on the form or none
    if (searchedLogEntries.length > 0) {
      this.setState({ filteredLogList: searchedLogEntries }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    } else {
      this.setState({ filteredLogList: [] }, () => {
        this.buildAndRenderPagination(this.state.filteredLogList.length);
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      });
    }
  }

  handleTagAndModelSearch = () => {
    const len = this.state.originalLogList.length;
    const searchedLogEntries = [];

    // If the input was only whitespaces
    if (/^(\s+)$/.test(this.state.formInput)) {
      alert(Strings.INSERT_VALID_ADDRESS0_TAG_OR_MODEL);
    }
    else {
      for (let i = 0; i < len; i++) {

        // Verify that the tag is not null
        if (this.state.originalLogList[i].tag !== null) {
          // Uppercases both strings before comparison to allow search flexibility
          if (this.state.originalLogList[i].tag.toUpperCase().indexOf(this.state.formInput.toUpperCase()) !== -1) {
            searchedLogEntries.push(this.state.originalLogList[i]);
          }
        }
      }
      // Show entries that matched the tag on the form or none
      if (searchedLogEntries.length > 0) {
        this.setState({ filteredLogList: searchedLogEntries }, () => {
          this.buildAndRenderPagination(this.state.filteredLogList.length);
          this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
        });
      } else {
        this.setState({ filteredLogList: [] }, () => {
          this.buildAndRenderPagination(this.state.filteredLogList.length);
          this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
        });
      }
    }
  }

  // Refreshes the page
  handleRefreshButtonClick = () => {
    this.setState({ filteredLogList: [], currentPage: 1, formInput: "" }, () => {
      document.getElementById("inputform").value = "";
      this.retrieveData();
    });
  }

  /*
    Saves the form input to the component state everytime the user types something in the form
  */
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  /*
    Handles user form submit 
    Filters the page list showing only the devices that match the event number, device address or tag
  */
  handleSubmit = () => {
    // Before doing any searches we empty the filtered log list and set
    // the current page to 1 to avoid problems
    this.setState({ filteredLogList: [], currentPage: 1 }, () => {
      if (this.state.formInput !== "" && addressRegex.test(this.state.formInput)) {
        this.handleAddressSearch();
      }
      else if (this.state.formInput !== "") {
        this.handleTagAndModelSearch();
      }
      else if (this.state.formInput === "") {
        this.buildAndRenderPagination(this.state.originalLogList.length);
        this.buildAndRenderActiveLogPage(this.state.currentPage);
      }
    });
  }

  // Creates a list with all log entries that match the address received from 
  // a click on the live list status cell
  handleCellStatusAddressSearch = () => {
    if (this.props.location.state !== undefined) {
      if (this.props.location.state.deviceAddress !== undefined) {
        cameFromLiveListClick = true;
        const len = this.state.originalLogList.length;
        const searchedEntries = [];

        for (let i = 0; i < len; i++) {
          if (this.state.originalLogList[i].address.toString() === this.props.location.state.deviceAddress.toString()) {
            searchedEntries.push(this.state.originalLogList[i]);
          }
        }

        // Show all log entries that matched the address or none
        if (searchedEntries.length > 0) {
          this.setState({ filteredLogList: searchedEntries }, () => {
            this.buildAndRenderPagination(this.state.filteredLogList.length);
            this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
          });
        } else {
          this.setState({ filteredLogList: [] }, () => {
            this.buildAndRenderPagination(this.state.filteredLogList.length);
            this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
          });
        }
      }
    }
  }

  retrieveData = async () => {
    this.showLoading();

    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "log/fisic", { mode: "cors", signal: this.state.controller.signal })
        .then(res => res.json())
        .then(data => data)
        .catch(() => "")
    );

    promissesArray.push(
      fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "homePage", { mode: "cors", signal: this.state.controller.signal })
        .then(res => res.json())
        .then(data => data)
        .catch(() => "")
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    let log = resolvedPromisses[0];
    let homePage = resolvedPromisses[1];

    if (log !== "" && homePage !== "") {
      this.setState({
        originalLogList: log,
        uptime: homePage.uptime
      }, () => {
        this.hideLoading();
        this.handleCellStatusAddressSearch();
        if (!cameFromLiveListClick) {
          this.buildAndRenderPagination(this.state.originalLogList.length);
          this.buildAndRenderActiveLogPage(this.state.currentPage);
        }
      });
    }
  }

  formatTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return <Table.Cell verticalAlign="middle" width="2">{dateToShow.toLocaleString("pt-BR")}</Table.Cell>;
    }
    else {
      if (logEntry.time !== undefined && logEntry.time !== null) {
        const eventTimeInMillis = logEntry.time * 1000;
        const uptimeInMillis = this.state.uptime * 1000;
        const timeNow = new Date().getTime();
        const time = timeNow - uptimeInMillis + eventTimeInMillis;
        const dateToShow = new Date(time);
        return <Table.Cell verticalAlign="middle" width="2">{dateToShow.toLocaleString("pt-BR")}</Table.Cell>;

      }
      else {
        return <Table.Cell verticalAlign="middle" width="2">{Strings.BEFORE_MONITOR_INIT_STR}</Table.Cell>;
      }
    }
  }

  /*
    Each page will show a maximum of 50 log entries
  */
  buildAndRenderPagination = (numOfLogEntries) => {
    // The number of pages should be the highest integer number after (log entries / 50)
    const numOfPages = Math.ceil(numOfLogEntries / 50);
    const pagination = <Pagination
      firstItem={null}
      lastItem={null}
      boundaryRange={1}
      defaultActivePage={this.state.currentPage}
      siblingRange={1}
      totalPages={numOfPages}
      onPageChange={this.handlePageChange} />;
    ReactDOM.render(pagination, document.getElementById("pagination-container"));
  }

  handlePageChange = (e, { activePage }) => {
    this.setState({ currentPage: activePage }, () => {
      // If the user came from a livelist click or has filtered the log
      if (cameFromLiveListClick || this.state.filteredLogList.length > 0) {
        this.buildAndRenderActiveFilteredLogPage(this.state.currentPage);
      }
      else {
        this.buildAndRenderActiveLogPage(this.state.currentPage);
      }
    });
  }

  buildAndRenderActiveLogPage = (activePageNumber) => {
    const listBeg = (activePageNumber - 1) * logListBeginMultiplier;         // Multiples of 50 (starting with 0)
    const listEnd = listBeg + logListEndMultiplier;                          // Multiples of 49 (49, 89, 129...)
    const listSize = this.state.originalLogList.length;
    const listToShow = [];

    for (let i = listBeg; i <= listEnd; i++) {
      // If the list size has not been reached yet
      if (i < listSize) {
        listToShow.push(this.state.originalLogList[i]);
      }
      // If the list element === undefined
      else {
        break;
      }
    }
    this.setState({ activeLogList: listToShow }, () => {
      let myDiv = document.getElementById("main-table-container");
      myDiv.scrollTop = 0;
    });
  }

  buildAndRenderActiveFilteredLogPage = (activePageNumber) => {
    const listBeg = (activePageNumber - 1) * logListBeginMultiplier;         // Multiples of 50 (starting with 0)
    const listEnd = listBeg + logListEndMultiplier;                          // Multiples of 49 (49, 89, 129...)
    const listSize = this.state.filteredLogList.length;
    const listToShow = [];

    for (let i = listBeg; i <= listEnd; i++) {
      // If the list size has not been reached yet
      if (i < listSize) {
        listToShow.push(this.state.filteredLogList[i]);
      }
      // If the list element === undefined
      else {
        break;
      }
    }
    this.setState({ activeLogList: listToShow }, () => {
      let myDiv = document.getElementById("main-table-container");
      myDiv.scrollTop = 0;
    });
  }

  /*
    Adjusts the size of the table so that it does not excced the
    browser window height limit
  */
  adjustTableMaxHeight = () => {
    const browserHeight = UtilsInstance.getBrowserWindowHeight();
    let newTableMaxHeight = browserHeight * Constants.SCALING_FACTOR_LOG;
    newTableMaxHeight = newTableMaxHeight.toString();
    newTableMaxHeight = newTableMaxHeight.concat("px");
    document.getElementById("main-table-container").style["maxHeight"] = newTableMaxHeight;
  }

  getAddressCell = (logEntry) => {
    if (logEntry.address !== undefined && logEntry.address !== null) {
      return <Table.Cell verticalAlign="middle" width="2">{logEntry.address}</Table.Cell>;
    }
    else {
      return <Table.Cell verticalAlign="middle" width="2">-</Table.Cell>;
    }
  }

  getTagCell = (logEntry) => {
    if (logEntry.tag === "") {
      return <Table.Cell verticalAlign="middle" width="2">-</Table.Cell>;
    }
    else if (logEntry.tag === Strings.NETWORK_EVENT) {
      return <Table.Cell verticalAlign="middle" width="2"></Table.Cell>;
    }
    else {
      return <Table.Cell verticalAlign="middle" width="2">{logEntry.tag}</Table.Cell>;
    }
  }

  getDescriptionCell = (logEntry) => {
    let cellText = "";


    if (logEntry.tipo === "attentionSignal") {
      cellText = logEntry.active ? Strings.DN_ATTENTION_SIGNAL_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL;
    }
    else if (logEntry.tipo === "badSignal") {
      cellText = logEntry.active ? Strings.DN_BAD_SIGNAL_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL;
    }
    else if (logEntry.tipo === "capacitiveEffect") {
      cellText = logEntry.active ? Strings.DN_CAPACITIVE_EFFECT_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL;
    }
    else if (logEntry.tipo === "noise") {
      cellText = logEntry.active ? Strings.DN_NOISE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS_PROTOCOL;
    }
    else if (logEntry.tipo === "estado") {
      cellText = <p><strong>{Strings.STATUS_CHANGE}</strong> {logEntry.description} </p>;
    }

    return <Table.Cell textAlign="left" verticalAlign="middle" width="4">{cellText}</Table.Cell>;
  }

  // Returns a table row corresponding to the information contained in the log entry
  getLogEntryTableRow = (logEntry) => {
    return (
      <Table.Row key={logEntry.event}>
        {this.formatTime(logEntry)}
        {this.getAddressCell(logEntry)}
        {this.getTagCell(logEntry)}
        {this.getDescriptionCell(logEntry)}
      </Table.Row>
    );
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.adjustTableMaxHeight();
  }

  componentDidUpdate() {
    this.adjustTableMaxHeight();
  }

  componentWillUnmount() {
    this.state.controller.abort();
  }

  // Render the table containing log entries
  render() {
    const filter = this.state.formInput;

    const activeLogList = this.state.activeLogList.map(logEntry => (
      this.getLogEntryTableRow(logEntry)
    ));

    return (
      <div style={screenStyle}>

        <Grid id="grid-id" columns="equal" textAlign="center" verticalAlign="middle">
          <Grid.Row>

            <Grid.Column>
              {
                // Left blank on purpouse so that we don't lose the 3-column grid alignment
              }
            </Grid.Column>

            <Grid.Column>
              <Form style={searchStyle} onSubmit={this.handleSubmit} >
                <Form.Input
                  placeholder={Strings.LOG_INPUT_TEXT_PLACEHOLDER_PROTOCOL}
                  id="inputform"
                  icon="search"
                  name="formInput"
                  value={filter}
                  onChange={this.handleChange} />
              </Form>
            </Grid.Column>

            <Grid.Column>
              <Button
                floated='right'
                icon="refresh"
                color="teal"
                size="big"
                onClick={this.handleRefreshButtonClick} />
            </Grid.Column>

          </Grid.Row>
        </Grid>

        <Table style={headerMarginStyle} celled fixed singleLine textAlign="center">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell width="2">
                {Strings.HORARY}
              </Table.HeaderCell>

              <Table.HeaderCell width="2">
                {Strings.ADDRESS}
              </Table.HeaderCell>

              <Table.HeaderCell width="2">
                {Strings.TAG}
              </Table.HeaderCell>

              <Table.HeaderCell width="4">
                {Strings.DESCRIPTION}
              </Table.HeaderCell>
            </Table.Row>

          </Table.Header>
        </Table>

        <div id="main-table-container" style={tableStyle}>
          <Table celled fixed striped textAlign="center">
            <Table.Body>{activeLogList}</Table.Body>
          </Table>
        </div>

        <div id="pagination-container"></div>

        <Loader size='big' active={this.state.isLoadingActive}>{Strings.LOG_WAITING}</Loader>

      </div>
    );
  }
}

// CSS custom table stylization
const screenStyle = {
  marginTop: "8px",
  marginLeft: "4px",
  marginRight: "4px",
  textAlign: "center"
};

const headerMarginStyle = {
  marginTop: "16px",
  marginBottom: "8px",
  width: "99%"
};

const tableStyle = {
  overflowY: "scroll",
  marginBottom: "16px"
};

const searchStyle = {
  marginBottom: "8px",
  width: "100%"
};

export default EventLog;
